import(/* webpackMode: "eager" */ "/vercel/path0/app/blog/[blogId]/page.tsx")